"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const createRootElement = id => {
  const rootContainer = document.createElement('div');
  if (id) {
    rootContainer.setAttribute('id', id);
  }
  return rootContainer;
};
const addRootElement = rootElem => {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};
const usePortal = id => {
  const rootElemRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const existingParent = id !== undefined && document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);
    if (!existingParent) {
      addRootElement(parentElem);
    }
    parentElem.appendChild(rootElemRef.current);
    return () => {
      parentElem.removeChild(rootElemRef.current);
      if (parentElem.childNodes.length === 0) {
        parentElem.parentNode.removeChild(parentElem);
      }
    };
  }, []);
  const getRootElem = () => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  };
  return getRootElem();
};
var _default = exports.default = usePortal;